/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Empty_TitleInputs */

const en_fw_bm_empty_title = /** @type {(inputs: Fw_Bm_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not enough evidence yet`)
};

const id_fw_bm_empty_title = /** @type {(inputs: Fw_Bm_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bukti belum cukup`)
};

/**
* | output |
* | --- |
* | "Not enough evidence yet" |
*
* @param {Fw_Bm_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_empty_title = /** @type {((inputs?: Fw_Bm_Empty_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Empty_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_empty_title(inputs)
	return en_fw_bm_empty_title(inputs)
});